import { render, staticRenderFns } from "./CommercialClaimForm.vue?vue&type=template&id=023405b0&scoped=true&"
import script from "./CommercialClaimForm.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023405b0",
  null
  
)

export default component.exports